import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useSetRecoilState } from 'recoil'
import { initialTourAtom } from '../../atoms'
import PriaWelcome from '../../assets/images/pria-welcome.png'
import { Typography } from '@mui/material'
import { PriaTour } from './PriaTour'
import PrimaryButton from '../Buttons/PrimaryButton'
import SecondaryButton from '../Buttons/SecondaryButton'
import authStorage from '../../services/authStorage'

const TOUR_DISMISSED_KEY = 'pria-initial-tour'

export const PriaModalTour = () => {
  const { t } = useTranslation()
  const setInitialTour = useSetRecoilState(initialTourAtom)

  const isDismissed = !!localStorage.getItem(TOUR_DISMISSED_KEY)
  const isAuthenticated = authStorage.isAuthenticated()

  const [open, setOpen] = useState(true)

  if (!isAuthenticated || isDismissed) return null

  const handleSeeLater = () => setOpen(false)

  const handleDismiss = () => {
    localStorage.setItem(TOUR_DISMISSED_KEY, 'dismissed')
    setOpen(false)
  }

  const handleDoTour = () => {
    localStorage.setItem(TOUR_DISMISSED_KEY, 'dismissed')
    setOpen(false)
    setInitialTour(true)
  }

  return (
    <>
      <Dialog
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: 8,
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }}
        maxWidth='md'
      >
        <IconButton onClick={handleDismiss} style={{ position: 'absolute', top: 32, right: 32, zIndex: 1 }} size='small'>
          <CloseOutlinedIcon fontSize='large' />
        </IconButton>
        <Stack width={1} height={1} justifyContent='space-between' sx={{ pt: 6 }} gap={2}>
          <Stack direction='row' gap={4}>
            <img src={PriaWelcome} alt='Pria Welcome' style={{ width: 250, objectFit: 'contain', borderRadius: '8px 0 0 8px' }} />
            <Stack pl={4} py={4} pr={8} gap={2}>
              <Typography variant='h2' fontSize={24} fontWeight={700} sx={{ color: 'var(--blue-color-5)' }}>
                {t('label.pria.asset.modal.tour.title')}
              </Typography>
              <Typography variant='body1'>
                <Trans i18nKey='label.pria.asset.modal.tour.description' components={{ bold: <strong />, br: <br /> }} />
              </Typography>
            </Stack>
          </Stack>
          <Stack direction='row' justifyContent='center' gap={3} mb={4} mx={4}>
            <SecondaryButton
              marginTop='0'
              onClick={handleSeeLater}
              label={t('label.pria.modal.tour.see.later')}
              width='100%'
              height='unset'
              padding='0px 20px !important'
            />
            <PrimaryButton onClick={handleDoTour} label={t('label.pria.modal.tour.do.tour')} width='100%' height='unset' />
          </Stack>
        </Stack>
      </Dialog>
      <PriaTour showTour={false} setShowTour={() => {}} />
    </>
  )
}
